import { useMediaQuery } from 'usehooks-ts';
import { useTheme } from '@mui/material';

interface MediaInfo {
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
    orientation: 'portrait' | 'landscape';
    width: number;
    height: number;
}

export const useMedia = (): MediaInfo => {
    const theme = useTheme();

    const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.values.sm}px)`);
    const isTablet = useMediaQuery(
        `(min-width: ${theme.breakpoints.values.sm}px) and (max-width: ${theme.breakpoints.values.md}px)`
    );
    const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.values.md}px)`);

    const isPortrait = useMediaQuery('(orientation: portrait)');

    const width = typeof window !== 'undefined' ? window.innerWidth : 0;
    const height = typeof window !== 'undefined' ? window.innerHeight : 0;

    const orientation: 'portrait' | 'landscape' = isPortrait ? 'portrait' : 'landscape';

    return {
        isMobile: isMobile || isTablet,
        isTablet,
        isDesktop,
        orientation,
        width,
        height
    };
};
